import React, { Component } from 'react';

require('./index.scss');

export default class FullscreenAd extends Component {
  static propTypes = {
    imageUrl: React.PropTypes.string,
    link: React.PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
  }

  handleClose = () => {
    this.setState({
      visible: false,
    });
  }

  render() {
    const { imageUrl, link = '' } = this.props;
    const { visible } = this.state;

    return imageUrl && visible
      ?
      <div className="fullscreen-ad">
        <a
          className="fullscreen-ad-link"
          href={link}
        >
          <img
            className="fullscreen-ad-image"
            src={imageUrl}
            alt="全屏广告"
          />
        </a>
        <div
          onClick={this.handleClose}
          className="fullscreen-ad-close"
        >
        </div>
      </div>
      :
      null;
  }
}



// WEBPACK FOOTER //
// ./src/component/fullscreen-ad/index.jsx